import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import NumberOfOccupants from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/NumberOfOccupants'
import ResidencePresence from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/ResidencePresence'
import RecentInsulationWorkField from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/RecentInsulationWorkField'
import EquipmentFields from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/EquipmentFields'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import ResponseField from './EstimationResponse/ResponseField'
import PresenceInDays from './PresenceInDays'

const EnergyLandscape = () => {
  const {
    isAllowedEnergyVertical,
    energyLandscapeAvailable,
    t,
    isCalculatingConsumption,
    triggerCalculateConsumption,
    energyLandscape,
  } = useAddress()

  if (!isAllowedEnergyVertical || !energyLandscapeAvailable) {
    return null
  }

  return (
    <>
      <PresenceInDays />
      <NumberOfOccupants />
      <ResidencePresence />
      <RecentInsulationWorkField />
      <EquipmentFields />
      <div>
        <SDButton
          style={{ width: '100%', marginBottom: '1rem' }}
          isLoading={isCalculatingConsumption}
          onClick={triggerCalculateConsumption}
        >
          {t('subscriptionTools:estimator.get_estimation')}
        </SDButton>
        <ResponseField consumption={energyLandscape?.consumptionEstimation ?? {}} />
      </div>
    </>
  )
}

export default EnergyLandscape
